export default "__VITE_ASSET__fec088c2__"